'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Subheader = require('./Subheader');

var _Subheader2 = _interopRequireDefault(_Subheader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Subheader2.default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/lib/Subheader/index.js
 ** module id = 279
 ** module chunks = 0
 **/